var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgVolumeOff = function SvgVolumeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.512,
    height: 18.028,
    viewBox: "0 0 22.512 18.028"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 589",
    transform: "translate(-1705.985 -612.473)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 83",
    d: "M1.993,16.932h3.79l4.52,4.79a1,1,0,0,0,1.71-.71V4.992a1,1,0,0,0-1.71-.71l-4.47,4.65H1.993a1,1,0,0,0-1,1v6A1,1,0,0,0,1.993,16.932Z",
    transform: "translate(1704.993 608.485)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 587"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 97",
    d: "M6.583,1.362,0,8",
    transform: "translate(1720.5 616.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 98",
    d: "M0,1.362,6.583,8",
    transform: "translate(1720.5 616.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
};
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMi41MTIiIGhlaWdodD0iMTguMDI4IiB2aWV3Qm94PSIwIDAgMjIuNTEyIDE4LjAyOCI+DQogIDxnIGRhdGEtbmFtZT0i0KHQs9GA0YPQv9C/0LjRgNC+0LLQsNGC0YwgNTg5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTcwNS45ODUgLTYxMi40NzMpIj4NCiAgICA8cGF0aCBkYXRhLW5hbWU9ItCa0L7QvdGC0YPRgCA4MyIgZD0iTTEuOTkzLDE2LjkzMmgzLjc5bDQuNTIsNC43OWExLDEsMCwwLDAsMS43MS0uNzFWNC45OTJhMSwxLDAsMCwwLTEuNzEtLjcxbC00LjQ3LDQuNjVIMS45OTNhMSwxLDAsMCwwLTEsMXY2QTEsMSwwLDAsMCwxLjk5MywxNi45MzJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNzA0Ljk5MyA2MDguNDg1KSIgZmlsbD0iI2ZmZiIvPg0KICAgIDxnIGRhdGEtbmFtZT0i0KHQs9GA0YPQv9C/0LjRgNC+0LLQsNGC0YwgNTg3Ij4NCiAgICAgIDxwYXRoIGRhdGEtbmFtZT0i0JrQvtC90YLRg9GAIDk3IiBkPSJNNi41ODMsMS4zNjIsMCw4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNzIwLjUgNjE2LjUpIiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIi8+DQogICAgICA8cGF0aCBkYXRhLW5hbWU9ItCa0L7QvdGC0YPRgCA5OCIgZD0iTTAsMS4zNjIsNi41ODMsOCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTcyMC41IDYxNi41KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iMiIvPg0KICAgIDwvZz4NCiAgPC9nPg0KPC9zdmc+DQo=";
export { SvgVolumeOff as ReactComponent };